import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { SorteioNfRoutingModule } from './sorteio.nf.routing.module';
import { SorteioNfComponent } from './sorteio.nf.component';
import {ShoppingFilterPipe} from '@app/core/pipe/shopping.filter.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ChainService} from '@app/chain/chain.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TextMaskModule} from 'angular2-text-mask';
import {CpfCnpjModule} from 'ng2-cpf-cnpj';
import {NgxMaskModule} from 'ngx-mask';
import {CustomerService} from '@app/customer/customer.service';

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    TranslateModule,
    NgbModule,
    TextMaskModule,
    CpfCnpjModule,
    NgxMaskModule.forRoot(),
    SorteioNfRoutingModule,
    FormsModule
  ],
  declarations: [
    SorteioNfComponent
  ],
  providers: [
    CustomerService
  ]

})
export class SorteioNfModule {
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/sorteio-nf/sorteio.nf.module.ts